// 环球指数,国际商品期货,美股中国概念股返回的是小分类如：6703，6704，比较第一位即可
const SH = 0 // 沪市
const SZ = 1 // 深市
const BK = 2 // 板块
const GZ_GZ_QH = 4 // 股指国债期货
const HK_STOCKS = 5 // 港股
const GLOBAL_INDEX = 6 // 环球指数
const GN_SPQH = 7 // 国内商品期货
const GJ_SPQH = 8 // 国际商品期货
const USA_CN_STOCKS = 9 // 美股中国概念股
const GJ_HL = 11 // 国际汇率
const RMB_PJ = 12 // 人民币牌价

export default {
  SH,
  SZ,
  BK,
  GZ_GZ_QH,
  HK_STOCKS,
  GLOBAL_INDEX,
  GN_SPQH,
  GJ_SPQH,
  USA_CN_STOCKS,
  GJ_HL,
  RMB_PJ
}
